import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import format from 'date-fns/format';
import { InfoOutlined } from '@material-ui/icons';
import { AnimatePresence } from 'framer-motion';
import Input, { INPUT_TYPES } from '../Input/Input';

const OpeningHourChangesetTable = ({
  allAreSelected,
  toggleSelectAllRows,
  drafts,
  toggleRowSelection,
  selected,
}) => {
  return (
    <table className="text-left w-full border-collapse bg-white table-fixed">
      <thead>
        <tr className="b-2-white">
          <th className="p-2 w-16">
            <Input
              id="select_all"
              name="select_all"
              type={INPUT_TYPES.CHECKBOX}
              onChange={() => toggleSelectAllRows(allAreSelected)}
              checked={allAreSelected}
              inputClassName="box_checkbox"
            />
          </th>
          <th className="p-2 font-normal w-32">Updated By</th>
          <th className="p-2 font-normal w-32">Updated On</th>
          <th className="p-2 font-normal">Opening Hour</th>
          <th className="p-2 font-normal w-32 text-right">Approvals</th>
        </tr>
      </thead>
      <tbody>
        <AnimatePresence initial={false}>
          {drafts.map(draft => {
            let totalApprovals = 0;
            if (draft.first_approver && draft.first_approver.trim()) {
              totalApprovals += 1;
            }
            if (draft.second_approver && draft.second_approver.trim()) {
              totalApprovals += 1;
            }
            return (
              <tr
                key={draft.id}
                className={cx('b-2-white', {
                  'bg-lightYellow': draft.operation_type === 'UPDATE',
                  'bg-lightGreen': draft.operation_type === 'CREATE',
                  'bg-lightRed': draft.operation_type === 'DELETE',
                })}>
                <td className="p-2">
                  <Input
                    id={draft.id}
                    name={draft.id}
                    type={INPUT_TYPES.CHECKBOX}
                    onChange={toggleRowSelection}
                    checked={selected[draft.id]}
                    inputClassName="box_checkbox"
                  />
                </td>
                <td className="p-2">{draft.modified_by}</td>
                <td className="p-2">
                  {format(new Date(draft.modified_at), 'd MMM yyyy')}
                </td>
                <td className="p-2 text-sm">
                  <div>Name: {draft.name}</div>
                  <div className="flex justify-between mt-2">
                    <div>Timezone: {draft.time_zone}</div>
                    <div>Type: {draft.type}</div>
                  </div>
                  <table className="time_bracket_table mt-4 w-full border-collapse">
                    <thead>
                      <tr>
                        <th> </th>
                        <th>From</th>
                        <th>To</th>
                      </tr>
                    </thead>
                    <tbody>
                      {draft.opening_hour_times.map(day => {
                        return (
                          <tr key={day.id}>
                            <td>{day.weekday}</td>
                            <td>{day.opening_time}</td>
                            <td>{day.closing_time}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </td>
                <td className="draft_approvers p-2">
                  <span>{`${totalApprovals}/2`}</span>
                  {Boolean(totalApprovals) && (
                    <InfoOutlined className="cursor-pointer" fontSize="small" />
                  )}
                  {Boolean(totalApprovals) && (
                    <span className="draft_approvers__list">
                      {draft.first_approver}, {draft.second_approver}
                    </span>
                  )}
                </td>
              </tr>
            );
          })}
        </AnimatePresence>
      </tbody>
    </table>
  );
};

OpeningHourChangesetTable.propTypes = {
  allAreSelected: PropTypes.bool.isRequired,
  toggleSelectAllRows: PropTypes.func.isRequired,
  drafts: PropTypes.array.isRequired,
  toggleRowSelection: PropTypes.func.isRequired,
  selected: PropTypes.object.isRequired,
};

export default  OpeningHourChangesetTable;
